var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('gift-cards',{staticClass:"mt-12",attrs:{"request-options":_vm.requestOptions}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }